import { Box } from '@mui/material';
import { MostRiskAssets } from './components/MostRiskAssets';
import useAppTheme from 'hooks/useAppTheme';
import { MonthlyMaintenanceCostDistribution } from './components/MonthlyMaintenanceCostDistribution';
import { FilterDependentSection } from './components/FilterDependentSection';
import { useState } from 'react';
import AssetDetailsView from '../DashboardV2/Components/AssetDetailsView';
import { type ServiceView } from 'types/survivalAnalysis.types';
import { AllAssetHealthScoreView } from './AllAssetsHealthScoreView.tsx/AllAssetHealthScoreView';
import { useSearchParams } from 'react-router-dom';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

const DashboardView = ({
  handleShowAssetDetails,
}: {
  handleShowAssetDetails: (
    value: boolean | null,
    paramSelectedAsset?: ServiceView,
    selectedView?: string
  ) => void;
}) => {
  const { enableDarkTheme } = useAppTheme();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const [selectedMonth, setSelectedMonth] = useState<string | null>(null);
  return (
    <Box py={2}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '70fr 30fr',
          gridTemplateRows: '438px', // same height
          width: '100%',
          gap: '16px',
          backgroundColor: enableDarkTheme
            ? palette.pageBackground
            : palette.pageBackground,
        }}
      >
        <Box sx={{ height: '100%' }}>
          <MonthlyMaintenanceCostDistribution
            setSelectedMonth={setSelectedMonth}
            selectedMonth={selectedMonth}
          />
        </Box>

        <Box sx={{ height: '100%' }}>
          <MostRiskAssets handleShowAssetDetails={handleShowAssetDetails} />
        </Box>

        {/* <Box sx={{ height: '100%' }}>
          <FrequentlyReplacedParts />
        </Box> */}
      </Box>
      <FilterDependentSection
        selectedMonth={selectedMonth}
        setSelectedMonth={setSelectedMonth}
      />
    </Box>
  );
};

export const SquaresDashboardV3 = () => {
  const [selectedAsset, setSelectedAsset] = useState<ServiceView>();
  const [showView, setShowView] = useState<string | null>('dashboard');
  const [searchParams, setSearchParams] = useSearchParams();
  const searchParamsViewValue = searchParams.get('view') ?? 'dashboard';
  // can be done in a single funciton but have to breakout cos backward compataibility #r1
  const handleShowAssetDetail = (
    value: boolean | null,
    paramSelectedAsset?: ServiceView,
    selectedView?: string
  ) => {
    if (value && paramSelectedAsset) {
      // backward compatible to show asset detail view
      setShowView('asset_detail');
      setSelectedAsset(paramSelectedAsset);
    } else if (selectedView === 'asset_health_score') {
      setShowView('asset_health_score');
      setSelectedAsset(undefined);
    } else {
      if (searchParamsViewValue === 'all_asset') {
        setShowView('asset_health_score');
      } else {
        setShowView('dashboard');
      }
      setSelectedAsset(undefined);
      setSearchParams({}, { replace: true });
    }
  };

  const handleBackClick = () => {
    setSelectedAsset(undefined);
    setShowView('dashboard');
  };

  return (
    <>
      {selectedAsset && showView === 'asset_detail' && (
        <AssetDetailsView
          setShowAssetDetails={handleShowAssetDetail}
          setSelectedAsset={setSelectedAsset}
          selectedAsset={selectedAsset}
          handleBackClick={handleBackClick}
        />
      )}
      {showView === 'asset_health_score' && (
        <AllAssetHealthScoreView
          handleShowAssetDetails={handleShowAssetDetail}
        />
      )}
      {showView === 'dashboard' && (
        <DashboardView handleShowAssetDetails={handleShowAssetDetail} />
      )}
    </>
  );
};
